var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"customizer-container","data-product":"81067","data-product-url":"#","data-product-type":"variable","data-product-view":"single"}},[_c('div',{attrs:{"id":"app"}},[_c('Customizer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }